/**
 * FOC-152 QA/test mode — mirrors the engineSelector persistence pattern:
 *   - `?test=1` (or `?test=true`) in the URL turns QA mode ON and persists it
 *   - any other explicit `?test=` value (`0`, `clear`, empty) turns it OFF
 *   - with no `?test=` param, the persisted value carries through
 *
 * When ON, scans carry `X-Focus-Test: 1` (see SearchRequestService), which the
 * engine (FOC-152 engine half) uses to EXCLUDE those scans from the
 * adjudication queue + the recognition stats — so QA/test scanning never
 * clutters the dashboard or skews metrics. A normal visitor never sets it, so
 * guest behavior is completely unchanged.
 *
 * Evaluated once at module load. Visit `?test=1` to stick in QA mode until
 * `?test=0`.
 */
const STORAGE_KEY = "barnes.snap.test_mode";

try {
  const urlTest = new URLSearchParams(window.location.search).get("test");
  if (urlTest === "1" || urlTest === "true") {
    localStorage.setItem(STORAGE_KEY, "1");
  } else if (urlTest !== null) {
    // any other explicit value (0 / clear / empty) turns QA mode off
    localStorage.removeItem(STORAGE_KEY);
  }
} catch {
  // URL / localStorage unavailable — QA mode simply stays off
}

export const TEST_MODE: boolean = (() => {
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
})();
